/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Bill_IdInputs */

const en_cargo_bill_id = /** @type {(inputs: Cargo_Bill_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bill ID`)
};

const es_cargo_bill_id = /** @type {(inputs: Cargo_Bill_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de factura`)
};

/**
* | output |
* | --- |
* | "Bill ID" |
*
* @param {Cargo_Bill_IdInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_bill_id = /** @type {((inputs?: Cargo_Bill_IdInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Bill_IdInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_bill_id(inputs)
	return es_cargo_bill_id(inputs)
});